import { useQuery, type UseQueryOptions } from "react-query";
import { genericFetch, getAPIOrigin, RequestHeaders } from "@certa/network";

// TYPES
type GetMessagesCountRequestPayload = {
  objectIds: string[];
  contentType: "workflow" | "step" | "field";
  allData?: boolean;
};

export type MessagesCount = {
  unread: number;
  all: number;
};

type GetMessagesCountResponse = {
  counts: Record<string, MessagesCount>;
};

// SERVICE
const getMessagesCount = async (
  payload: GetMessagesCountRequestPayload
): Promise<GetMessagesCountResponse> => {
  const requestOptions: RequestInit = {
    method: "POST",
    headers: RequestHeaders.POST,
    credentials: "include",
    body: JSON.stringify({
      object_ids: payload.objectIds,
      content_type: payload.contentType,
      all_data: payload.allData
    })
  };

  const response = await genericFetch(
    `${getAPIOrigin()}/api/v2/messages-count/`,
    requestOptions
  );
  return messagesCountModelCreator(response);
};

// MODELS
const messagesCountModelCreator = (response: any): GetMessagesCountResponse => {
  return {
    counts: response.counts
  };
};

const getMessagesCountQueryKey = (
  objectIds: string[],
  contentType: "workflow" | "step" | "field",
  allData?: boolean
) => {
  return ["getMessagesCount", objectIds, contentType, allData];
};

// HOOK
export const useGetMessagesCount = (
  config: GetMessagesCountRequestPayload,
  extraConfig?: UseQueryOptions<GetMessagesCountResponse>
) =>
  useQuery({
    queryKey: getMessagesCountQueryKey(
      config.objectIds,
      config.contentType,
      config.allData
    ),
    queryFn: () => getMessagesCount(config),
    enabled: config.objectIds.length > 0 && config.contentType !== undefined,
    ...extraConfig
  });
